import "./Footer.scss";
import { useNavigate } from "react-router-dom";

const Footer = () => {
  const navigate = useNavigate();
  return (
    <div className="footer">
      <div className="mainfooter">
        <div>
          <img src="/LogoBlanc.png" alt="footer" />
          <div id="sptitle">SP HYGIÈNE</div>
          <div>
            Z.I. La Prairie
            <br />
            91140 Villebon-sur-Yvette
          </div>
          <div>01 69 34 92 28</div>
          <div>
            <a href="mailto:info@sphygiene.com">info@sphygiene.com</a>
          </div>
        </div>
        <div>
          <div>
            <div>NOS PRODUITS</div>
            <div
            // onClick={() => navigate(`/category-product`)}
            >
              Tous nos produits
            </div>
            <div onClick={() => navigate(`/commitment`)}>
              Ecolabel & Ecocert
            </div>
            <div onClick={() => navigate(`/commitment`)}>Made in France</div>
            <div
            // onClick={() => navigate(`/category-product`)}
            >
              Catalogue
            </div>
          </div>
          <div>
            <div>L’ENTREPRISE</div>
            <div onClick={() => navigate(`/about`)}>A propos</div>
            <div onClick={() => navigate(`/commitment`)}>Notre engagement</div>
            <div onClick={() => navigate(`/contact`)}>Nous contacter</div>
            <div>CGV & Livraison</div>
          </div>
          <div>
            <div>MON COMPTE</div>
            <div>Connexion</div>
            <div>Mes commandes</div>
            <div>Mes adresses</div>
            <div>Mes informations</div>
          </div>
        </div>
        <div className="list-mobile">
          <div onClick={() => navigate(`/`)}>NOS PRODUITS</div>
          <div onClick={() => navigate(`/about`)}>A PROPOS</div>
          <div onClick={() => navigate(`/commitment`)}>ENGAGEMENT</div>
          <div onClick={() => navigate(`/contact`)}>CONTACT</div>
        </div>
      </div>
      <div className="mention">
        <div>Mentions légales</div>
        <div>Politique de confidentialité</div>
      </div>
    </div>
  );
};

export default Footer;
